export enum StreamingRoutes {
  LastFrame = 'last-frame',
}
